export const example = (params: any) => {
  console.log('example event handler with params:', params);
};
